import { render, staticRenderFns } from "./cuDiabetes.vue?vue&type=template&id=4d0a0f0a&scoped=true"
import script from "./cuDiabetes.vue?vue&type=script&lang=js"
export * from "./cuDiabetes.vue?vue&type=script&lang=js"
import style0 from "./cuDiabetes.vue?vue&type=style&index=0&id=4d0a0f0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0a0f0a",
  null
  
)

export default component.exports